import { render, staticRenderFns } from "./SlideUp2.vue?vue&type=template&id=d6453c00&scoped=true&"
import script from "./SlideUp2.vue?vue&type=script&lang=js&"
export * from "./SlideUp2.vue?vue&type=script&lang=js&"
import style0 from "./SlideUp2.vue?vue&type=style&index=0&id=d6453c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6453c00",
  null
  
)

component.options.__file = "SlideUp2.vue"
export default component.exports